<template>
  <v-app class="application">
    <alert></alert>
    <loading></loading>
    <confirm></confirm>
    <vetalfa-ads></vetalfa-ads>
    <vetalfa-purchases v-if="!!user"></vetalfa-purchases>
    <v-content v-if="loadContent" style="overflow: hidden !important">
      <v-row justify="center" class="ma-0 pa-0 vetalfa-row vetalfa-background">
        <router-view></router-view>
      </v-row>
    </v-content>
    <input type="text" class="copy-to-clipboard" id="copy-to-clipboard" />
  </v-app>
</template>

<style>
@import "./vetalfa.css";
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import messages from "@/constants/messages.js";
import Loading from "@/components/Loading.vue";
import Alert from "@/components/Alert.vue";
import Confirm from "@/components/Confirm.vue";
import Ads from "@/components/complete/Ads.vue";
import Purchases from "@/components/Purchases.vue";
export default {
  name: "App",
  components: {
    loading: Loading,
    alert: Alert,
    confirm: Confirm,
    "vetalfa-ads": Ads,
    "vetalfa-purchases": Purchases,
  },
  computed: {
    ...mapGetters("general", ["user"]),
  },
  data: () => ({
    loadContent: false,
  }),
  methods: {
    ...mapActions("general", ["partnersRedirect"]),
  },
  watch: {},
  created: async function () {
    try {
      if (this._isCordovaApp()) {
        this.loadContent = true;
      } else if (InstallTrigger !== "undefined") {
        if (process.env.VUE_APP_ENV === "partners") {
          throw new Error();
        }
        alert(messages.FIREFOX_SUPPORT);
      }
    } catch {
      if (process.env.VUE_APP_ENV === "partners") {
        this.loadContent = await this.partnersRedirect();
      } else {
        this.loadContent = true;
      }
    }
  },
};
</script>
